import styles from "./index.module.scss";
import { Button } from "../Button";
import { Modal } from "@mui/material";
import close from "../../../assets/images/close-icon.svg";
import GrayLine from "../GrayLine";
import requestIcon from "../../../assets/images/request-icon.svg";

interface CustomPopUpProps {
  open: boolean;
  onclose?: () => void;
  description: string;
  onConfirm: () => void;
  confirmText: string;
}
const CustomPopup: React.FC<CustomPopUpProps> = ({
  open,
  onclose,
  description,
  onConfirm,
  confirmText,
}) => {
  return (
    <Modal
      open={open}
      onClose={onclose}
      className={styles.modal}
      data-testid="custom-popup-modal"
    >
      <div className={styles.container} data-testid="custom-popup-container">
        <div className={styles.header} data-testid="custom-popup-header">
          <div
            className={styles.headContainer}
            data-testid="custom-popup-head-container"
          >
            <div
              className={
                styles.modalHeader
              }
              data-testid="custom-popup-icon-title"
            >
              <img
                src={
                  requestIcon
                }
                alt="request icon"
                className={
                  styles.errorIcon
                }
                data-testid="custom-popup-icon"
              />
              <p>Important</p>
            </div>
            {onclose && (
              <div
                className={styles.closeIcon}
                data-testid="custom-popup-close-icon-container"
              >
                <img
                  src={close}
                  alt="close"
                  className={styles.closeIcon}
                  onClick={onclose}
                  data-testid="custom-popup-close-icon"
                />
              </div>
            )}
          </div>
          <GrayLine data-testid="custom-popup-gray-line" />
        </div>
        <p
          id="popup-description"
          className={styles.containerText}
          data-testid="custom-popup-description"
        >
          {description}
        </p>
        
          <div
            className={styles.buttonContainer}
            data-testid="custom-popup-button-container"
          >
            <Button
              onClick={onConfirm}
              buttonClassName={styles.confirmButton}
              buttonTextClassName={styles.confirmText}
              datatestid="custom-popup-confirm-button"
              datatestidText={`${confirmText}`}
            >
              {confirmText}
            </Button>
          </div>
      </div>
    </Modal>
  );
};

export default CustomPopup;
